<template>
  <div v-if="loading" class="text-center mb-3">
    <b-spinner variant="primary"></b-spinner>
  </div>
  <div v-else class="px-2">
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="d-flex flex-column">
      <h1 style="display: flex;justify-content: center;">Webportal Footer</h1>
      <form>
        <div class="form-group">
          <label class="footerLabels">Footer Logo</label>
          <!-- <input class="form-control" type="file" /> -->
          <div>
            <div class="d-flex justify-content-start">
              <button class="btn btn-light border border-dark" type="button"
                      @click="showModalLogo = true">Add
                Logo
              </button>
            </div>
            <div v-if="showModalLogo">
              <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                   class="modal fade show" role="dialog" style="display: block;"
                   tabindex="-1">
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                      <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                              type="button" @click="showModalLogo = false"></button>
                    </div>
                    <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                      <select-logo :fetchId="footerData.footer_logo_id" @logoImg="getLogo"/>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-primary" data-bs-dismiss="modal" type="button"
                              @click="selectImgForLogo">Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <figure class="figure text-center"
                    style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
              <div v-if="logo_file_path != null">
                <img :src="imageBasePath + logo_file_path"
                     style="min-height: 100px;max-height: 130px;max-width: 60%;object-fit: contain">
              </div>
            </figure>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Footer Text</label>
              <div>
                <div class="form-group mt-1">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-start mb-2">
                      <button class="btn btn-info btn-lg" type="button"
                              @click="showModalText = true">Add
                        Media
                      </button>
                    </div>
                    <div v-if="showModalText">
                      <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                           class="modal fade show" role="dialog"
                           style="display: block;" tabindex="-1">
                        <div class="modal-dialog modal-xl">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 id="exampleModalFullscreenLabel" class="modal-title h4">
                                Add
                                Media</h5>
                              <button aria-label="Close" class="btn-close"
                                      data-bs-dismiss="modal" type="button"
                                      @click="showModalText = false"></button>
                            </div>
                            <div class="modal-body">
                              <show-all-media-component/>
                            </div>
                            <div class="modal-footer">
                              <button class="btn btn-secondary" data-bs-dismiss="modal"
                                      type="button"
                                      @click="showModalText = false">Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Editor :htmlFetch="footerData.text" style="margin-top: 5px;"
                          @htmlData='setFooterTextBn'>
                  </Editor>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="footerLabels">Footer Planning</label>
              <div>
                <div class="form-group mt-1">



                                    <textarea v-if="isEditEnabledPlanning" v-model="footerData.planning"
                                              class="form-control mt-2 "
                                              rows="3"></textarea>
                  <div v-if="!isEditEnabledPlanning" class="mt-2" rows="3"
                       style="background-color: white; border-color: #000; border-radius: 2px; border-width: 2px; height: 200px;"
                       v-html="footerData.planning">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="footerLabels">Footer Contact</label>
              <textarea v-model="footerData.contact" class="form-control" type="text"></textarea>
            </div>

            <div class="form-group">
              <label class="footerLabels">Footer Address</label>
              <textarea v-model="footerData.address" class="form-control" type="text"></textarea>
            </div>

            <div class="form-group">
              <label class="footerLabels">Copyright Text</label>
              <textarea v-model="footerData.copyright_text" class="form-control" type="text"></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Footer Text(English)</label>
              <div>
                <div class="form-group mt-1">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-start mb-2">
                      <button class="btn btn-info btn-lg" type="button"
                              @click="showModalText = true">Add
                        Media
                      </button>
                    </div>
                  </div>
                  <Editor :htmlFetch="footerData.text_en" style="margin-top: 5px;"
                          @htmlData='setFooterTextEn'></Editor>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="footerLabels">Footer Planning(English)</label>
              <div>
                <div class="form-group mt-1">
                                    <textarea v-if="isEditEnabledPlanning" v-model="footerData.planning_en"
                                              class="form-control mt-2 "
                                              rows="3"></textarea>
                  <div v-if="!isEditEnabledPlanning" class="mt-2" rows="3"
                       style="background-color: white; border-color: #000; border-radius: 2px; border-width: 2px; height: 200px;"
                       v-html="footerData.planning_en">
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="footerLabels">Footer Contact(English)</label>
              <textarea v-model="footerData.contact_en" class="form-control" type="text"></textarea>
            </div>
            <div class="form-group">
              <label class="footerLabels">Footer Address(English)</label>
              <textarea v-model="footerData.address_en" class="form-control" type="text"></textarea>
            </div>
            <div class="form-group">
              <label class="footerLabels">Copyright Text(English)</label>
              <textarea v-model="footerData.copyright_text_en" class="form-control"
                        type="text"></textarea>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="footerLabels">Partners</label>
          <div class="d-flex justify-content-start">
            <button class="btn btn-light border border-dark" type="button"
                    @click="showModalPartners = true">Add
              Media
            </button>
          </div>
          <div v-if="showModalPartners">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;"
                 tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                            type="button" @click="showModalPartners = false"></button>
                  </div>
                  <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                    <selectable-media-component :fetchImageIds="footerData.partner_image_id_list"
                                                @imgList="getImages"/>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                            @click="showModalPartners = false">Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <figure class="figure d-flex gap-2 text-center flex-wrap"
                  style="margin-top: 6px;background-color: rgb(255, 255, 255);padding: 5px;width: fit-content;border-radius: 4px;">
            <div v-for="image in pathList" :key="image.media_file_id"
                 style="padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;width: fit-content;border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
              <img :src="imageBasePath + image"
                   style="height: 100px;max-width: 200px;object-fit: contain">
            </div>
          </figure>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Facebook Link</label>
              <input v-model="footerData.facebook_link" class="form-control" type="text"/>
            </div>

            <div class="form-group">
              <label class="footerLabels">Twitter Link</label>
              <input v-model="footerData.twitter_link" class="form-control" type="text"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Instagram Link</label>
              <input v-model="footerData.instagram_link" class="form-control" type="text"/>
            </div>

            <div class="form-group">
              <label class="footerLabels">Youtube Link</label>
              <input v-model="footerData.youtube_link" class="form-control" type="text"/>
            </div>
          </div>
        </div>


        <div class="d-flex justify-content-end">
          <button class="btn btn-dark" type="button" @click="sendData">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import FooterService from '@/services/footer.service.js';
import showAllMedia from '@/components/Media/ShowAllMedia.vue';
import selectableMedia from '@/components/Media/SelectableMedia.vue';
import selectLogo from '@/components/Media/SelectLogo.vue';
import mediaService from '@/services/media.service';
import Config from '@/config/index';
import Editor from "../../components/Editor";

export default {
  name: 'PortalFooter',
  components: {
    "select-logo": selectLogo,
    "show-all-media-component": showAllMedia,
    "selectable-media-component": selectableMedia,
    Editor
  },

  created() {
    this.imageBasePath = Config.apiFileBasePath;
    this.loadFooterData();
  },

  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          to: '/portal-header'
        }, {
          text: 'Footer Options',
          href: '#'
        }
      ],
      imageBasePath: null,
      showModalText: false,
      showModalPlanning: false,
      showModalLogo: false,
      showModalPartners: false,
      isEditEnabledText: true,
      isEditEnabledBanglaText: true,
      isEditEnabledPlanning: true,
      imageList: [],
      logo_file_path: null,
      logo_media_file_id: null,
      footerData: {
        footer_theme_id: 1,
        footer_logo_id: "",
        text: "",
        text_en: "",
        planning: "",
        planning_en: "",
        address: "",
        address_en: "",
        contact: "",
        contact_en: "",
        copyright_text: "",
        copyright_text_en: "",
        facebook_link: "",
        twitter_link: "",
        instagram_link: "",
        youtube_link: "",
        partner_image_id_list: [],
      },
      imageBodyList: [],
      pathList: [],
      loading: false,
    }
  },
  methods: {
    getImages(data) {
      this.pathList = [];
      this.footerData.partner_image_id_list = [];
      const parsedData = JSON.parse(data);
      parsedData.forEach((element) => {
        this.pathList.push(element[0].file_path);
        this.footerData.partner_image_id_list.push(element[0].media_file_id);
      });

    },

    setFooterTextBn(data) {
      this.footerData.text = data;
    },
    setFooterTextEn(data) {
      this.footerData.text_en = data;
    },
    getLogo(data) {
      this.logo_file_path = data.file_path;
      this.footerData.footer_logo_id = data.media_file_id;
    },
    async loadFooterData() {
      this.loading = true;
      try {
        const response = await FooterService.getFooter();
        this.loading = false;

        if (response.data) {
          this.footerData.text = response.data.footer_text;
          this.footerData.text_en = response.data.footer_text_eng;
          this.footerData.planning = response.data.footer_planning;
          this.footerData.planning_en = response.data.footer_planning_eng;
          this.footerData.contact = response.data.footer_contact;
          this.footerData.contact_en = response.data.footer_contact_eng;
          this.footerData.address = response.data.footer_address;
          this.footerData.address_en = response.data.footer_address_eng;
          this.footerData.copyright_text = response.data.footer_copy_right_text;
          this.footerData.copyright_text_en = response.data.footer_copy_right_text_eng;
          this.footerData.facebook_link = response.data.footer_facebook_link;
          this.footerData.twitter_link = response.data.footer_twitter_link;
          this.footerData.instagram_link = response.data.footer_instagram_link;
          this.footerData.youtube_link = response.data.footer_youtube_link;
          this.footerData.footer_logo_id = response.data.logo;
          const logo = await this.getLogoFromId(response.data.logo);


          this.logo_file_path = logo.file_path;
          this.footerData.footer_logo_id = logo.media_file_id;

          const pathPromises = response.data.footer_partners.map(async (element) => {
            const path = await this.getLogoFromId(element.image);
            return path;
          });
          const pathList = await Promise.all(pathPromises);
          this.pathList = [];
          pathList.forEach((element) => {
            this.pathList.push(element.file_path);
            this.footerData.partner_image_id_list.push(element.media_file_id);
          });
        } else {
          this.showNotification('error', response.data.message);
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async getLogoFromId(id) {
      const logo = await mediaService.getOneMedia(id);
      return logo.data;
    },
    selectImgForLogo() {
      this.showModalLogo = false;
    },
    turnPreviewOnText() {
      this.isEditEnabledText = false;
    },
    turnEditOnText() {
      this.isEditEnabledText = true;
    },
    turnPreviewOnBanglaText() {
      this.isEditEnabledBanglaText = false;
    },
    turnEditOnBanglaText() {
      this.isEditEnabledBanglaText = true;
    },

    turnPreviewOnPlanning() {
      this.isEditEnabledPlanning = false;
    },
    turnEditOnPlanning() {
      this.isEditEnabledPlanning = true;
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Footer',
        text: message,
      });
    },
    async sendData() {
      this.imageBodyList = [];
      for (let index = 0; index < this.footerData.partner_image_id_list.length; index++) {
        const element = this.footerData.partner_image_id_list[index];
        this.imageBodyList.push(
            {
              "id": element,
            }
        );
      }
      this.footerData.partner_image_id_list = this.imageBodyList;
      try {
        this.loading = true;
        const response = await FooterService.updateFooter(this.footerData);
        this.loading = false;
        if (response.data) {
          this.showNotification('success', response.data.message);
          await this.loadFooterData();
        } else {
          this.showNotification('error', response.data.message);
        }

      } catch (error) {
        this.loading = false;
      }

    }
  }
}

</script>

<style scoped>
.footerLabels {
  font-weight: 700;
  margin-top: 5px;
}
</style>
